/* eslint-disable react/react-in-jsx-scope */
import './style.css'
import { useNavigate } from 'react-router-dom'

import boxOne from '../../img/1.png'
import boxTwo from '../../img/2.png'
import boxThree from '../../img/3.png'
import boxFour from '../../img/4.png'
import boxFive from '../../img/5.png'

const GoldBonus = () => {
  const navigate = useNavigate()
  const handleBtnClick = (path, anchor) => {
    navigate(`${path}#${anchor}`)
  }
  return (
    <>
      <section className="gold center">
        <div className="gold-box">
          <h1 className="gold-title">ЗОЛОТОЙ БОНУС</h1>
          <h2 className="gold-prog-txt">Описание программы:</h2>
          <p className="gold-info-txt">
            Специальное предложение для кинопрофессий, представленных
            в&nbsp;киношколе{' '}
            <span className="yellow-span">
              Free&nbsp;Sun&nbsp;Film&nbsp;School
            </span>.
            Программа предназначена для&nbsp;
            <span className="yellow-span">лучших студентов</span>, обеспечивая{' '}
            <span className="yellow-span">
              индивидуальное карьерное сопровождение
            </span>{' '}
            и&nbsp;интеграцию в&nbsp;киноиндустрию. Лучшие студенты получают
            возможность{' '}
            <span className="yellow-span">
              бесплатного членства и&nbsp;стажировку в&nbsp;Клубе Free&nbsp;Sun.
            </span>
          </p>
          <h2 className="gold-conditions">Условия отбора лучших студентов:</h2>
          <p className="gold-info-txt">
            Отбор проходит после просмотра дипломных работ куратором
            и&nbsp;мастером курса. Оцениваются как&nbsp;теоретические знания,
            так&nbsp;и&nbsp;профессиональные навыки, проявленные в&nbsp;процессе
            обучения.
          </p>
        </div>
      </section>

      <div className="bonus center">
        <div className="bonus-conteiner">
          <div className="bonus-box bonus-box-bot bonus-box-pos-top">
            <img className="bonus-img" src={boxOne} alt="" />
            <div className="bonus-box-txt">
              <h2 className="bonus-title">
                АКТЕРСКОЕ МАСТЕРСТВО: ЗОЛОТОЙ БОНУС
              </h2>
              <p className="bonus-txt">
                1. Индивидуальная консультация от мастера курс — получите ценные
                рекомендации и&nbsp;советы от&nbsp;профессионала.
              </p>
              <p className="bonus-txt">
                2. Персональная встреча с менеджером — получите рекомендации по
                развитию карьеры&nbsp;и&nbsp;продвижению в индустрии.
              </p>
              <p className="bonus-txt">
                3. Знакомство с кастинг-агентами — начните строить свою карьеру
                с правильных контактов.
              </p>
              <p className="bonus-txt">
                4. Клуб FREE SUN — станьте частью эксклюзивного клуба,
                открывающего доступ&nbsp;к&nbsp;закрытым мастер-классам
                и&nbsp;питчингам&nbsp;киношколы, а также к участию
                в&nbsp;проектах FREE&nbsp;SUN PRODUCTION.
              </p>
            </div>
          </div>
          <div className="bonus-box bonus-box-bot bonus-box-pos">
            <img className="bonus-img" src={boxTwo} alt="" />
            <div className="bonus-box-txt">
              <h2 className="bonus-title bonus-title-col">
                ПРОДЮСИРОВАНИЕ РЕКЛАМЫ: ЗОЛОТОЙ БОНУС
              </h2>
              <p className="bonus-txt bonus-txt-col">
                1. Индивидуальная консультация от мастера курса — получите
                уникальные знания и&nbsp;инсайты от&nbsp;профессионала.
              </p>
              <p className="bonus-txt bonus-txt-col">
                2. Персональная встреча с менеджером — получите советы по
                карьерному росту и&nbsp;развитию.
              </p>
              <p className="bonus-txt bonus-txt-col">
                3. Практика ассистентом мастера курса на&nbsp;съемочной площадке
                — начните свой путь&nbsp;с&nbsp;реального опыта в индустрии.
              </p>
              <p className="bonus-txt bonus-txt-col">
                4. Клуб FREE SUN — получите доступ к&nbsp;закрытым
                мастер-классам и питчингам и&nbsp;участвуйте в&nbsp;проектах
                FREE SUN PRODUCTION.
              </p>
            </div>
          </div>
          <div className="bonus-box">
            <img className="bonus-img" src={boxThree} alt="" />
            <div className="bonus-box-txt">
              <h2 className="bonus-title bonus-title-col">
                РЕЖИССУРА: ЗОЛОТОЙ БОНУС
              </h2>
              <p className="bonus-txt bonus-txt-col">
                1. Индивидуальная консультация от мастера курса — воспользуйтесь
                опытом наставника для&nbsp;достижения своих целей.
              </p>
              <p className="bonus-txt bonus-txt-col">
                2. Персональная встреча с менеджером — получите советы по
                успешному карьерному продвижению.
              </p>
              <p className="bonus-txt bonus-txt-col">
                3. Клуб FREE SUN — участвуйте в мастер-классах, питчингах и
                проектах FREE SUN PRODUCTION, став частью киносообщества.
              </p>
            </div>
          </div>

          <div className="bonus-box ">
            <img className="bonus-img" src={boxFour} alt="" />
            <div className="bonus-box-txt">
              <h2 className="bonus-title">
                СЦЕНАРНОЕ МАСТЕРСТВО: ЗОЛОТОЙ БОНУС
              </h2>
              <p className="bonus-txt">
                1. Индивидуальная консультация от мастера курса — узнайте
                секреты создания успешных сценариев.
              </p>
              <p className="bonus-txt">
                2. Персональная встреча с менеджером — получите советы по
                развитию сценарной карьеры.
              </p>
              <p className="bonus-txt">
                3. Клуб FREE SUN — откройте доступ к&nbsp;закрытым
                мастер-классам и питчингам, и&nbsp;станьте частью проектов FREE
                SUN PRODUCTION.
              </p>
            </div>
          </div>
          <div className="bonus-box ">
            <img className="bonus-img" src={boxFive} alt="" />
            <div className="bonus-box-txt">
              <h2 className="bonus-title">
                СЦЕНАРНОЕ МАСТЕРСТВО: ЗОЛОТОЙ БОНУС
              </h2>
              <p className="bonus-txt">
                1. Индивидуальная консультация от мастера курса —получите
                эксклюзивные знания и&nbsp;рекомендации.
              </p>
              <p className="bonus-txt">
                2. Клуб FREE SUN — получите бесплатный доступ к мастер-классам и
                участвуйте в&nbsp;проектах продакшена FREE SUN.{' '}
              </p>
              <p className="bonus-txt">
                3. Менторинг и работа под руководством М.Томяка на проектах ТНТ
                продакшен — уникальная возможность развиваться
                под&nbsp;руководством настоящего мастера.
              </p>
            </div>
          </div>
        </div>
        <div className="bonus-line-box">
          <svg
            className="bonus-line"
            width="1667"
            height="100"
            viewBox="0 0 1667 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 41L1665 41"
              stroke="#FBDF00"
              strokeWidth="4"
              strokeLinecap="round"
            />
            <path
              d="M375 1V41"
              stroke="#FBDF00"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M943 1V21V41"
              stroke="#FBDF00"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M655 41V97"
              stroke="#FBDF00"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M1227 41V83"
              stroke="#FBDF00"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M116 43V81"
              stroke="#FBDF00"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </div>
      </div>

      <div className="btn">
        <button
          className="btn-gold"
          onClick={() => handleBtnClick('/', 'courses')}
        >
          подробнее
        </button>
      </div>
    </>
  )
}

export default GoldBonus
